module.exports = __webpack_public_path__ + "img/header-bg-m-en.f693d9cc.png";